import { ActualCostStatusIndicator } from '@/features/financials/components/common/ActualCostStatusIndicator';
import { useVisibleActualCost } from '../context/VisibleActualCostsContext';
import type { ItemsTableRow } from '../types';
import { OrgCurrencyCell } from './OrgCurrencyCell';

export const ActualCostCell = ({ row }: { row: ItemsTableRow }) => {
  const entry = useVisibleActualCost(row.id);
  if (!entry) return null;

  return (
    <div className="flex w-full items-center justify-between gap-1">
      <OrgCurrencyCell amount={entry.value} />
      <ActualCostStatusIndicator status={entry.status} />
    </div>
  );
};
